import { Shop } from './shop.model';
import { BillingInfo } from './billing-info.model';
import { Coupon } from './coupon.model';
import { Plan } from './shop.model';
import { Addon, IncludedAddons } from './addon.model';

export enum SUBSCRIPTION_STATUS {
  ACTIVE = 'active',
  FUTURE = 'future',
  IN_TRIAL = 'in_trial',
  TRIAL_ENDED = 'trial_ended',
  NON_RENEWING = 'not_renewing',
  PAUSED = 'paused',
  CANCELLED = 'cancelled',
  UNKNOWN = 'unknown',
}

export interface Subscription {
  id: string;
  company_id: number;
  chargebee_customer_id: string;
  chargebee_subscription_id: string;
  billing_info: BillingInfo;
  plan: Plan;
  addons: Addon[];
  status: SUBSCRIPTION_STATUS;
  creation_date: Date | string;
  trial_end_date: Date | string;
  activation_date: Date | string;
  next_billing_date: Date | string;
  due_invoices_count: number;
  monthly_total_cost: number;
  promotional_credit: number;
  refundable_credit: number;
  meta_data: Metadata;
  applied_coupons: Coupon[];
  payment_verification_required: boolean;
  fraud_prevention_enabled: boolean;
  generated_link_id?: string;
  phone_number_count?: number; 
}

export interface Metadata {
  plan_upgrade: { version: string };
  shop: Shop;
  max_dids: number;
  available_payment_methods: string[];
  pbx: {
    device_types: {
      desktop_app: number;
      csp: number;
      desk_phone: number;
      sip: number;
    };
  };
  pricing_info: { commitment_days: number; default_user_count: number };
  included_addons: IncludedAddons;
  max_users: number;
  users: { min: number; max: number };
  traffic: {
    initial_credit: number;
    outbound: { mobile: number; countries: string[]; landline: number }[];
  };
  subscription: { 'update-flow': string };
}

export interface PBX {
  alphaname: string;
  company_id: number;
  company_name: string;
  country: string;
  id: number;
  is_enabled: boolean;
  kazoo_id: string;
  kazoo_instance_id: string;
  kazoo_account_enabled: boolean;
  language: string;
  outboundFlag: string;
  outbound_did: any;
  play_temporary_did_media: boolean;
  realm: string;
  time_zone: string;
  call_recording_configuration: CallRecordingConfiguration
}

export interface PivotModel {
  inbound: string;
  outbound: string;
}

export interface PivotConfig {
  pbxId: number;
  callLimit: number;
  integrationsEnabled: boolean;
  channelLimitNotificationsEnabled: boolean;
  channelLimitSlackInternalMessageEnabled: boolean;
}

export interface CreditModel {
  value: number;
}

export interface PaymentInfoModel {
  brand?: string;
  creation_date: string;
  expiry_month?: number;
  expiry_year?: number;
  id: string;
  last_four_digits: string;
  masked_number?: string;
  reference_id?: string;
  status: string;
  type: string;
  mandate_id?: string;
  name_on_account?: string;
}

export interface CallRecordingConfiguration {
  id?: number;
  internal_enabled: boolean;
  outbound_enabled: boolean;
  inbound_enabled: boolean;
}